var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry-list"},[_c('entry-projects-group',{attrs:{"heading":"Active Projects","projects":_vm.activeProjects,"currentProject":_vm.currentProject}}),_vm._v(" "),_c('entry-projects-group',{attrs:{"heading":"Archived","projects":_vm.inactiveProjects,"currentProject":_vm.currentProject,"is-archive":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }